import cartAPI from 'apis/cart';

import type {
  ExpandedCartProduct,
  CartProductMaybeThumb,
  CartProductForCreate,
  CartProductForUpdate,
} from 'domains/cart_products';

type PreviewResponse = Pick<CartProductMaybeThumb, 'thumbnail_url' | 'preview_url'>;

export const all = async () => {
  const response = await cartAPI.get<CartProductMaybeThumb[]>('/products');
  return response.data;
};

export const find = async (id: number) => {
  const response = await cartAPI.get<ExpandedCartProduct>(`/products/${id}`);
  return response.data;
};

export const create = async (cp: CartProductForCreate) => {
  const response = await cartAPI.post<{ id: number }>('/products', cp);
  return response.data;
};

export const update = async (cp: CartProductForUpdate) => {
  await cartAPI.patch(`/products/${cp.id}`, cp);
  return cp;
};

export const destroy = async (id: number) => {
  await cartAPI.delete(`/products/${id}`);
  return id;
};

export const getThumbnail = async (id: number) => {
  const response = await cartAPI.get<PreviewResponse>(`/products/${id}/preview`);

  if (response.status === 204) {
    throw new Error('No Thumbnail Yet');
  }

  return response.data;
};
